import styled from 'styled-components';
import {Link} from 'react-router-dom';
import {media} from '../../styles/components/media-queries';

export const Page = styled.div`
  max-width: 110rem;
  margin: 0 auto;
  color: #1a1a2e;
  background: #eef0f5;
`;

export const Hero = styled.div`
  position: relative;
  overflow: hidden;
  min-height: 42rem;
  border-radius: 1rem;
  display: flex;
  align-items: center;

  ${media.small`
    min-height: 36rem;
    border-radius: 0;
  `};
`;

export const HeroImg = styled.img`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center 38%;
`;

export const HeroOverlay = styled.div`
  position: absolute;
  inset: 0;
  background: linear-gradient(
    90deg,
    rgba(8, 9, 74, 0.93) 0%,
    rgba(8, 9, 74, 0.65) 52%,
    rgba(8, 9, 74, 0.08) 100%
  );
`;

export const HeroContent = styled.div`
  position: relative;
  z-index: 2;
  padding: 0 5.6rem;
  max-width: 62rem;

  ${media.small`
    padding: 0 1.8rem;
  `};
`;

export const LogoBadge = styled.div`
  display: inline-flex;
  align-self: flex-start;
  flex-shrink: 0;
  border-radius: 1rem;
  margin-bottom: 1rem;
`;

export const Logo = styled.img`
  display: block;
  height: 7.5rem;
  width: auto;
`;

export const HeroBadge = styled.span`
  display: block;
  background: rgba(70, 152, 204, 0.2);
  border: 1px solid #4698cc;
  color: #7ec8f0;
  font-size: 1.1rem;
  font-weight: 700;
  letter-spacing: 0.16rem;
  padding: 0.5rem 1.4rem;
  border-radius: 2rem;
  width: fit-content;
`;

export const HeroTitle = styled.h1`
  color: ${p => p.theme.primaryTextColor};
  font-size: 4.2rem;
  font-weight: 700;
  line-height: 1.12;
  margin: 1rem 0;

  ${media.small`
    font-size: 3rem;
  `};
`;

export const HeroSub = styled.p`
  color: rgba(255, 255, 255, 0.65);
  font-size: 1.6rem;
  line-height: 1.65;
  margin-bottom: 2.8rem;
  ${media.small`
    margin-bottom: 1.8rem;
  `};
`;

export const HeroButtons = styled.div`
  display: flex;
  gap: 1.4rem;
  align-items: center;
  flex-wrap: wrap;
`;

export const PrimaryButton = styled(Link)`
  background: #4698cc;
  color: ${p => p.theme.primaryTextColor};
  font-size: 1.4rem;
  font-weight: 700;
  padding: 1.3rem 2.8rem;
  border-radius: 0.6rem;
  border: none;
  white-space: nowrap;
  text-decoration: none;
  display: inline-block;

  &:hover {
    background: #3a85b8;
  }
`;

export const GhostButton = styled.a`
  color: rgba(255, 255, 255, 0.8);
  font-size: 1.4rem;
  padding: 1.2rem 2rem;
  border-radius: 0.6rem;
  border: 1px solid rgba(255, 255, 255, 0.32);
  cursor: pointer;
  background: transparent;
  text-decoration: none;
  display: inline-block;
  transition: border-color 0.15s;

  &:hover {
    border-color: rgba(255, 255, 255, 0.6);
  }
`;

export const Wrap = styled.div`
  padding: 0 3.2rem;

  ${media.small`
    padding: 0 2rem;
  `};
`;

export const Why = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 2rem;
  margin-top: 2.8rem;

  ${media.small`
    grid-template-columns: 1fr;
  `};
`;

export const WhyCard = styled.div`
  background: #fff;
  border-radius: 0.8rem;
  padding: 2.6rem 2.8rem;
`;

export const Eyebrow = styled.p`
  font-size: 1rem;
  font-weight: 700;
  letter-spacing: 0.14rem;
  color: #4698cc;
  margin-bottom: 1rem;
  text-transform: uppercase;
`;

export const WhyCardTitle = styled.h3`
  font-size: 1.8rem;
  font-weight: 700;
  color: #1c1373;
  margin-bottom: 1rem;
  line-height: 1.2;
`;

export const WhyCardBody = styled.p`
  font-size: 1.4rem;
  color: #5a5a6a;
  line-height: 1.65;
`;

export const Partner = styled.div`
  margin-top: 2rem;
  background: #e6ebf6;
  padding: 1.8rem 2.2rem;
  display: flex;
  align-items: center;
  gap: 1.6rem;
`;

export const PartnerBar = styled.div`
  width: 0.4rem;
  min-height: 2.8rem;
  background: #4698cc;
  border-radius: 0.3rem;
  flex-shrink: 0;
  align-self: stretch;
`;

export const PartnerText = styled.p`
  font-size: 1.5rem;
  color: #1c1373;
  line-height: 1.6;
  font-style: italic;
`;

export const Shop = styled.div`
  margin-top: 3.2rem;
`;

export const ShopHeader = styled.div`
  margin-bottom: 1.8rem;
`;

export const ShopHeading = styled.h2`
  font-size: 2.2rem;
  font-weight: 700;
  color: #1c1373;
`;

export const CatGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 1.4rem;

  ${media.small`
    grid-template-columns: 1fr 1fr;
  `};
`;

export const CatTile = styled(Link)`
  background: #fff;
  border-radius: 0.8rem;
  overflow: hidden;
  cursor: pointer;
  display: block;
  text-decoration: none;
  color: inherit;
  transition: transform 0.15s, box-shadow 0.15s;

  &:hover {
    transform: translateY(-0.2rem);
    box-shadow: 0 0.6rem 2rem rgba(0, 0, 0, 0.1);
  }
`;

export const CatTileSwatch = styled.div`
  width: 100%;
  height: 15rem;
  background: linear-gradient(
    160deg,
    ${p => p.$from || '#cfe4f5'},
    ${p => p.$to || '#ffffff'}
  );
`;

export const CatTileImg = styled.img`
  width: 100%;
  height: 15rem;
  object-fit: cover;
`;

export const CatTileBody = styled.div`
  padding: 1.4rem 1.6rem 1.6rem;

  h4 {
    font-size: 1.4rem;
    font-weight: 700;
    color: #1c1373;
    margin: 0.4rem 0;
  }

  p {
    font-size: 1.2rem;
    color: #6a6a80;
    line-height: 1.45;
  }
  ${media.small`
    padding: 0.5rem 1.4rem 0 1.4rem;
  `};
`;

export const CatTileCta = styled(CatTile)`
  background: #4698cc;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 21.4rem;

  &:hover {
    background: #3a85b8;
    transform: translateY(-0.2rem);
  }
`;

export const CatTileCtaBody = styled.div`
  padding: 1.4rem 2rem;
  text-align: center;

  h4 {
    color: ${p => p.theme.primaryTextColor};
    font-size: 1.5rem;
    font-weight: 700;
    margin-bottom: 0.4rem;
  }

  p {
    color: rgba(255, 255, 255, 0.85);
    font-size: 1.2rem;
    line-height: 1.45;
  }
`;

export const Trust = styled.div`
  margin-top: 3.2rem;
  display: grid;
  grid-template-columns: repeat(4, 1fr);

  ${media.small`
    grid-template-columns: repeat(2, 1fr);
  `};
`;

export const TrustItem = styled.div`
  text-align: center;
  padding: 1rem 0;
  border-right: 1px solid rgba(28, 19, 115, 0.12);

  &:last-child {
    border-right: none;
  }
`;

export const TrustNum = styled.div`
  font-size: 2.6rem;
  font-weight: 700;
  color: #1c1373;
  line-height: 1;
  margin-bottom: 0.5rem;
`;
export const TrustNumSmall = styled.span`
  font-size: 1.4rem;
  vertical-align: top;
`;

export const TrustLabel = styled.div`
  font-size: 1.2rem;
  color: #4698cc;
  font-weight: 600;
`;

export const Testimonial = styled.div`
  margin-top: 2.8rem;
  background: #e6ebf6;
  padding: 2.4rem 2.8rem;
  display: flex;
  gap: 2rem;
  align-items: flex-start;
`;

export const TestimonialMark = styled.div`
  font-size: 6.4rem;
  color: #4698cc;
  line-height: 0.7;
  font-family: Georgia, serif;
  flex-shrink: 0;
  opacity: 0.25;
  margin-top: 0.6rem;
`;

export const TestimonialBody = styled.p`
  font-size: 1.5rem;
  color: #1a1a2e;
  line-height: 1.7;
  margin-bottom: 0.8rem;

  strong {
    font-weight: 700;
  }
`;

export const TestimonialAttr = styled.p`
  font-size: 1.1rem;
  color: #4698cc;
  font-weight: 700;
  letter-spacing: 0.05rem;
  text-transform: uppercase;
`;

export const Faq = styled.div`
  margin-top: 3.2rem;
  border-bottom: 1px solid #d0d3de;
`;

export const FaqHeading = styled.h2`
  font-size: 2rem;
  font-weight: 700;
  color: #1c1373;
  margin-bottom: 1.4rem;
`;

export const FaqItem = styled.button`
  width: 100%;
  background: none;
  border: none;
  border-top: 1px solid #d0d3de;
  padding: 1.6rem 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1.6rem;
  cursor: pointer;
  text-align: left;
`;

export const FaqQuestion = styled.span`
  font-size: 1.4rem;
  color: #2a2a3e;
  line-height: 1.45;
`;

export const FaqIcon = styled.span`
  display: inline-flex;
  flex-shrink: 0;
  transition: transform 0.2s;
  transform: rotate(${p => (p.$open ? '180deg' : '0deg')});
  &::before {
    font-family: 'icomoon';
    content: '\\e910';
    font-size: 2.2rem;
    font-weight: normal;
    color: #4698cc;
  }
`;

export const FaqAnswer = styled.div`
  font-size: 1.3rem;
  color: #5a5a6a;
  line-height: 1.65;
  padding-bottom: 1.4rem;
  padding-right: 4rem;
  /* Stays in the DOM (and the SSR'd HTML) even when collapsed, so search engines can still
     index it — only visually hidden, not conditionally rendered. */
  display: ${p => (p.$open ? 'block' : 'none')};
`;

export const FooterCta = styled.div`
  margin-top: 3.6rem;
  background: #08094a;
  padding: 2.8rem 3.2rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 2.4rem;
  flex-wrap: wrap;

  ${media.small`
    padding: 2.4rem 2rem;
  `};
`;

export const FooterCtaText = styled.div`
  color: ${p => p.theme.primaryTextColor};
  font-size: 2rem;
  font-weight: 700;
  line-height: 1.25;
`;

export const FooterCtaSub = styled.div`
  color: rgba(255, 255, 255, 0.5);
  font-size: 1.3rem;
  margin-top: 0.4rem;
`;

export const SubText = styled.div`
  padding: 2rem 0 0;
  font-style: italic;
`;
